import urlApiV2 from '@/router/urlApiV2'
import Vue from 'vue'
import Toast from 'vue-toasted'

Vue.use(Toast)
export default {

	// RELATÓRIO AULAS PRÁTICAS PENDENTES
    async getPraticasPendentes (data, callback) {
        Vue.http.get(urlApiV2 + `/aulas/praticas/relatorio/pendentes?dataInicial=${data.dataInicial}&dataFinal=${data.dataFinal}`)
            .then(response => {
                callback(response.data)
            })
            .catch(error => {
                this.launchToast('fa-warning', error.data.mensagem)
                callback(error.data)
            })
    },

    async getPraticasAgendadasHoje (callback) {
        Vue.http.get(urlApiV2 + `/export/planilha/aulas/praticas/agendadas-hoje`)
        .then(response => {
            callback(response.data)
        })
        .catch(error => {
            this.launchToast('fa-warning', error.data.mensagem)
            callback(error.data)
        })
    },

    async getPraticasPorPeriodo (data, callback) {
        Vue.http.get(urlApiV2 + `/export/planilha/aulas/praticas/periodo?dataInicial=${data.dataInicial}&dataFinal=${data.dataFinal}`)
            .then(response => {
                callback(response.data)
            })
            .catch(error => {
                this.launchToast('fa-warning', error.data.mensagem)
                callback(error.data)
            })
    },

    async getTeoricasAgendadasHoje (callback) {
        Vue.http.get(urlApiV2 + `/export/planilha/turmas-teoricas/agendadas-hoje`)
        .then(response => {
            callback(response.data)
        })
        .catch(error => {
            this.launchToast('fa-warning', error.data.mensagem)
            callback(error.data)
        })
    },

    async getTeoricasAgendadasPeriodo (data, callback) {
      Vue.http.get(urlApiV2 + `/export/planilha/turmas-teoricas/agendadas-periodo?dataInicial=${data.dataInicial}&dataFinal=${data.dataFinal}`)
        .then(response => {
            callback(response.data)
        })
        .catch(error => {
            this.launchToast('fa-warning', error.data.mensagem)
            callback(error.data)
        })
    },

    async getTeoricasAguardandoProcessamento (callback) {
        Vue.http.get(urlApiV2 + `/turmas/relatorio/teoricas/status/aguardandoprocessamento`)
        .then(response => {
            callback(response.data)
        })
        .catch(error => {
            this.launchToast('fa-warning', error.data.mensagem)
            callback(error.data)
        })
    },

    async getTeoricasRejeitadas (data, callback) {
        Vue.http.get(urlApiV2 + `/export/planilha/aulas/teoricas/pendentes?dataInicial=${data.dataInicial}&dataFinal=${data.dataFinal}`)
        .then(response => {
            callback(response.data)
        })
        .catch(error => {
            this.launchToast('fa-warning', error.data.mensagem)
            callback(error.data)
        })
    },

    async getQuantidadeFotosTeoricas (data, callback) {
        Vue.http.get(urlApiV2 + `/export/planilha/aulas/teoricas/quantidade-fotos?day=${data.day}`)
        .then(response => {
            callback(response.data)
        })
        .catch(error => {
            this.launchToast('fa-warning', error.data.mensagem)
            callback(error.data)
        })
    },

    async getAulasPorPeriodo(data, callback) {
      Vue.http.get(urlApiV2 + `/export/planilha/aulas/teoricas/quantidade-alunos?dataInicial=${data.dataInicial}&dataFinal=${data.dataFinal}`)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        this.launchToast('fa-warning', error.data.mensagem)
        callback(error.data)
      })
    },

    async getQuantidadeFotosPraticas (data, callback) {
        Vue.http.get(urlApiV2 + `/export/planilha/aulas/praticas/quantidade-fotos?day=${data.day}`)
        .then(response => {
            callback(response.data)
        })
        .catch(error => {
            this.launchToast('fa-warning', error.data.mensagem)
            callback(error.data)
        })
    },

	// ALERT TOAST
	launchToast (icon, msg) {
		Vue.toasted.show(msg, {
			icon: icon,
			position: 'top-right',
			duration: 5000,
			fullWidth: false
		})
	},

}
